import { Link } from 'react-router-dom';
import SEOHead from '@/components/base/SEOHead';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import GameCard from '@/components/feature/GameCard';
import { newGames } from '@/data/games';

export default function NewGames() {
  return (
    <>
      <SEOHead
        title="New Yono Apps 2026 – Latest Yono Games and APK Downloads"
        description="Discover the newest Yono apps and games for 2026. Browse recently added Yono games, get the latest APK downloads, and find fresh gaming experiences for Android."
        keywords="New Yono Apps, Latest Yono Games, New Yono Games 2026, Yono APK Downloads, Android Games"
      />

      <Header />

      <main>
        <div className="px-4 py-5">
          <span className="inline-block px-2 py-0.5 bg-accent-100 text-accent-700 rounded-full text-[10px] font-semibold mb-2">
            Fresh &amp; New
          </span>
          <h1 className="text-xl font-heading font-bold text-foreground-900 mb-1">
            New Yono Apps 2026
          </h1>
          <p className="text-foreground-500 text-[12px] leading-relaxed mb-1">
            Stay ahead with the newest Yono apps. Each listing includes direct APK download links and full game details.
          </p>
          <p className="text-foreground-400 text-[10px] mb-4">
            Last updated: July 13, 2026
          </p>

          {newGames.length === 0 ? (
            <div className="text-center py-16">
              <div className="w-14 h-14 rounded-2xl bg-background-100 flex items-center justify-center mx-auto mb-3">
                <i className="ri-gamepad-line text-xl text-foreground-400"></i>
              </div>
              <p className="text-foreground-500 text-sm">No new games at the moment. Check back soon!</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 gap-2">
              {newGames.map((game) => (
                <GameCard key={game.id} game={game} />
              ))}
            </div>
          )}

          <div className="mt-6 text-center">
            <Link
              to="/games"
              className="inline-flex items-center gap-1.5 px-5 py-2.5 bg-background-100 text-foreground-700 rounded-full text-[13px] font-semibold hover:bg-background-200 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-arrow-left-line text-sm"></i>
              Browse All Games
            </Link>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}